module.exports = __webpack_public_path__ + "static/img/clear.f689af03.png";